import React from 'react';

const LinkExpired = () => (
  <div style={{ position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#20252b', color: '#fff', fontFamily: 'Inter, Arial, sans-serif', textAlign: 'center', padding: 24 }}>
    <img src="/images/Cinesplat_Logo_White.svg" alt="" width={40} height="auto" style={{ marginBottom: 18 }} />
    <p style={{ fontSize: 17, fontWeight: 500, margin: 0 }}>This link has expired</p>
  </div>
);

export default LinkExpired;
